/*
 * @Author: your name
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Date: 2021-07-12 17:20:08
 * @LastEditTime: 2022-10-20 09:58:35
 * @Motto: Your smile is my rainbow
 * @Website: https://www.fairy520.top/
 * @Github: https://github.com/CharlsPrince
 * @FilePath: \maine:\git\xadc\src\utils\axios\projectProgress.api.js
 * @Description: Do not edit
 */
import Http from '@/utils/httpRequest'
const axios = new Http()

export default {
  // 获取项目进度查询和办理列表
  // getProjectProgressList(params) {
  //   return axios.post('/gcjsxm/public/list', params)
  // },
  // 获取进度查询头部条件配置
  getStatusConfig() {
    return axios.get('/config/dchy/public/getProgressQueryStatus')
  },
  // 进度查询 type == 7时为满意度评价
  getProjectList(params) {
    return axios.post('/onlineServiceProject/dchy/public/QueryEntrust', params)
  },
  // 获取项目进度查询和办理详情列表
  getProjectDetailList(params) {
    return axios.post('/applet/jdcx/public/progressqQueryDet', params)
  },
  // 获取项目详细信息
  getProjectInfo(params) {
    return axios.post('/onlineServiceProject/public/getProjectInfo', params)
  },
  // // 撤回多测项目
  // recallCommitment(params) {
  //   return axios.post('/onlineServiceProject/public/recallCommitment', params)
  // },
  // // 结束委托
  // endCommission(params) {
  //   return axios.post('/lhchywdjb/public/endCommission', params)
  // },
  // 查看满意度评价信息
  getSatisfactionInfo(params) {
    return axios.get('/satisfaction/public/getSatisfactionInfo', {params})
  },
  // 满意度评价选项配置
  getSatisfactionItem(params) {
    return axios.get('/satisfaction/dchy/public/getSatisfactionItem', {params})
  },
  // 分项满意度评价提交
  rateSubmit(params) {
    return axios.post('/satisfaction/dchy/public/submit', params)
  },
  // 总体满意度评价提交
  allRateSubmit(params) {
    return axios.post('/satisfaction/dchy/public/overallEvaluations', params)
  },
  // 发送手机验证码
  sendVerification(params) {
    return axios.get('/validate/public/sendVerification', {
      params
    })
  },
  // 成果确认
  addSubsystem(params) {
    return axios.post('/onlineServiceProject/public/resultsConfirm', params)
  },
  // 成果退回
  realNameVerify(params) {
    return axios.get('/onlineServiceProject/public/resultsReturn', params)
  },
  //进度查询-确认接口
  surveyConfirm(params) {
    return axios.post('/onlineServiceProject/public/surveyConfirm', params)
  },
  //进度查询-退回接口
  surveyReturn(params) {
    return axios.post('/onlineServiceProject/public/surveyReturn', params)
  },
  //进度查询-撤回接口
  surveyRecall(params) {
    return axios.post('/onlineServiceProject/public/recall', params)
  },
  //进度查询-删除接口
  surveyDelete(params) {
    return axios.get('/onlineServiceProject/public/DeleteTemporarilyByCode', params)
  }
}
